import React, { useEffect, useState } from "react";
import useWindowDimensions from "./useWindowsDimensions";

export enum ResponsiveMaskBreakpoints {
  Sm = "sm",
  Md = "md",
  Lg = "lg",
  Xl = "xl",
  Xl2 = "xl2",
}

export const widthBreakpointSizes: Record<ResponsiveMaskBreakpoints, number> = {
  [ResponsiveMaskBreakpoints.Sm]: 640,
  [ResponsiveMaskBreakpoints.Md]: 768,
  [ResponsiveMaskBreakpoints.Lg]: 1024,
  [ResponsiveMaskBreakpoints.Xl]: 1280,
  [ResponsiveMaskBreakpoints.Xl2]: 1536,
};

type MaskType = {
  maskSvg: React.SVGAttributes<SVGElement>;
  maskId: string;
};

interface IResponsiveMaskInput {
  desktopMask: MaskType;
  mobileMask: MaskType;
  widthBreakpoint?: ResponsiveMaskBreakpoints;
}

interface IResponsiveMaskOutput {
  mask: React.SVGAttributes<SVGElement>;
  maskId: string;
}

const useResponsiveMask = ({
  desktopMask,
  mobileMask,
  widthBreakpoint = ResponsiveMaskBreakpoints.Md,
}: IResponsiveMaskInput): IResponsiveMaskOutput => {
  const { width } = useWindowDimensions();
  const [currentMask, setCurrentMask] = useState<MaskType>({} as MaskType);

  useEffect(() => {
    setCurrentMask(
      width > widthBreakpointSizes[widthBreakpoint] ? desktopMask : mobileMask
    );
  }, [width]);

  return { mask: currentMask.maskSvg, maskId: currentMask.maskId };
};

export default useResponsiveMask;
